import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("title2", component(opts));
  editor.BlockManager.add("title2", block(opts));
};